import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import './Login.css';
import ParachuteAnimation from '../components/Parachute';
import { useAuth } from '../context/AuthContext';


const Login = () => {
  const [formData, setFormData] = useState({
        email: '',
        password: '',
        rememberMe: false
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const { isLoggedIn, userRole, login, logout } = useAuth();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    setError('');
    setIsLoading(true);
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
        
        if (response.ok) {
          const data = await response.json();
          login(data.access_token, data.user);
          navigate('/');  // Navigate to the home page or update the app state
        } else {
          const errorData = await response.json();
          setError('Login failed');
        }
      } catch (error) {
        console.error('Login error:', error);
      } finally {
        setIsLoading(false);
      }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="logo-container">
          <img src="/logo.png" alt="Parachute" className="logo" />
        </div>
        <ParachuteAnimation />

        <div className="stats-container">
          <div className="stats-graphic">
            <div className="stats-bar"></div>
            <div className="stats-bar"></div>
            <div className="stats-bar"></div>
            <div className="stats-bar"></div>
          </div>
          <h2 className="stats-number">100K+</h2>
          <p className="stats-text">People got hired</p>
        </div>

        {/* <div className="testimonial-container">
          <div className="testimonial-avatar-container">
            <img src="https://via.placeholder.com/50" alt="Adam Sandler" className="testimonial-avatar" />
            <div className="testimonial-info">
              <h4>Adam Sandler</h4>
              <p>Lead Engineer at Canva</p>
            </div>
          </div>
          <div className="testimonial-quote">
            <p>"Great platform for the job seeker that searching for new career heights."</p>
          </div>
        </div> */}
      </div>
      
      <div className="login-right">
        
        <div className="login-form-container">
          <h1 className="welcome-text">Welcome Back</h1>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}
                    
          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="Enter email address" 
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input 
                type="password" 
                id="password" 
                name="password" 
                placeholder="Enter password" 
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-checkbox">
              <input 
                type="checkbox" 
                id="remember" 
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="remember">Remember me</label>
            </div>
            
            <button type="submit" className="login-button">              
                {isLoading ? (
                <>
                  <span className="spinner"></span>
                  Logging in...
                </>
              ) : 'Login'}</button>
          </form>
          
          <div className="signup-link">
            Don't have an account? <a href="/signup">Sign Up</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;